(ns kyber.subscriptions.ui
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
 :ui/tooltip
 (fn [db _]
   (get-in db [:kyber-ui :tooltip])))

(re-frame/reg-sub
 :ui/is-fullscreen
 (fn [db _]
   (boolean (:ui/is-fullscreen db))))
